import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const AVAILABLE_EXTERNAL_FIELDS_QUERY_KEY = 'integrations-available-external-fields';

export function useGetAvailableExternalFieldsQuery({
	integrationProvider,
	objectType = 'Contact',
	impersonationContext,
	enabled = true,
	meta,
}: {
	integrationProvider: Api.IntegrationProvider;
	objectType?: string | null;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			const queryParams = objectType ? `?objectType=${objectType}` : '';
			return userSession.webServiceHelper.callAsync<Api.IExternalField[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `integrations/${integrationProvider}/availableFields/external${queryParams}`,
				}),
				'GET'
			);
		},
		queryKey: [AVAILABLE_EXTERNAL_FIELDS_QUERY_KEY, integrationProvider, objectType, impersonationContext],
		meta,
	});
}

export const invalidateAvailableExternalFieldsQuery = ({
	impersonationContext,
}: {
	impersonationContext: Api.IImpersonationContext;
}) => reactQueryClient.invalidateQueries({ queryKey: [AVAILABLE_EXTERNAL_FIELDS_QUERY_KEY, impersonationContext] });
